import * as Immutable from 'immutable';
import * as React from 'react';
import NewButtonContainer from '../_containers/NewButtonContainer';
import SaveButtonContainer from '../_containers/SaveButtonContainer';
import OrderNowButtonContainer from '../_containers/OrderNowButtonContainer';

export type Props = {
	direction?: string
}

export default class PatternActionButtons extends React.Component<Props> {
	render = () => {
		let direction = this.props.direction ? this.props.direction : '';
		return <div className={direction + " action-buttons"} >
			<NewButtonContainer />
			<SaveButtonContainer />
			<OrderNowButtonContainer />
		</div>
	}
}